import script from "./ProjectMetrics.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectMetrics.vue?vue&type=script&setup=true&lang=js"

import "./ProjectMetrics.vue?vue&type=style&index=0&id=00fd3299&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00fd3299"]])

export default __exports__